import LeafletMap from "../components/leafletMap/LeafletMap";
import "./App.css";
import {
  AppInsightsContext,
  AppInsightsErrorBoundary,
} from "@microsoft/applicationinsights-react-js";
import { setUpAppInsights, reactPlugin } from "./applicationInsights";
import { useEffect } from "react";
import ErrorBoundaryFallback from "../components/errorBoundaryFallback/ErrorBoundaryFallback";

const App = () => {
  useEffect(() => {
    setUpAppInsights();
  }, []);
  return (
    <AppInsightsErrorBoundary onError={ErrorBoundaryFallback} appInsights={reactPlugin}>
      <AppInsightsContext.Provider value={reactPlugin}>
        <LeafletMap />
      </AppInsightsContext.Provider>
    </AppInsightsErrorBoundary>
  );
};

export default App;
